"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = _interopRequireDefault(require("@loadable/component"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Lazy-load Lottie animations with a delay.


var Lottie = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var delay = props.delay;
  var LottieAnimation = (0, _component.default)(function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        return resolve(Promise.resolve().then(function () {
          return _interopRequireWildcard(require('./LottieAnimation'));
        }));
      }, delay);
    });
  });
  return /*#__PURE__*/_react.default.createElement(LottieAnimation, _extends({
    ref: ref
  }, props));
});

Lottie.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  renderer: _propTypes.default.string,
  rendererSettings: _propTypes.default.shape({
    preserveAspectRatio: _propTypes.default.string
  }),
  data: _propTypes.default.object,
  path: _propTypes.default.string,
  segments: _propTypes.default.array,
  // Events
  onInit: _propTypes.default.func,
  onDestroy: _propTypes.default.func,
  // Options
  delay: _propTypes.default.number,
  autoPlay: _propTypes.default.bool,
  loop: _propTypes.default.bool,
  speed: _propTypes.default.number,
  direction: _propTypes.default.number,
  activateOnHover: _propTypes.default.bool,
  pauseOnClick: _propTypes.default.bool,
  olaTime: _propTypes.default.number,
  startPosition: _propTypes.default.number,
  ariaLabel: _propTypes.default.string
};
Lottie.defaultProps = {
  id: null,
  className: null,
  renderer: 'svg',
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid meet'
  },
  data: null,
  path: null,
  segments: null,
  // Events
  onInit: function onInit() {},
  onDestroy: function onDestroy() {},
  // Options
  delay: null,
  autoPlay: true,
  loop: true,
  speed: 1,
  direction: 1,
  activateOnHover: false,
  pauseOnClick: false,
  ariaLabel: 'animation',
  olaTime: 300,
  startPosition: null
};
var _default = Lottie;
exports.default = _default;